import { isRefreshTokenForbidden } from '@services/api/useRefreshToken/forbiddenScenarios'
import { useUserAuth } from '@core/modules/Auth/composables/useUserAuth'
import { useUserLogout } from '@core/modules/Auth/composables/useUserLogout'

import { addAuthWorkerListener } from './authWorkerClient'

// ***
// HANDLERS
// ***

export function handleWorkerCheckTokenExpiration() {
  const { handleRefreshTokenRequestProcess } = useUserAuth()
  addAuthWorkerListener('checkTokenExpiration', () => {
    handleRefreshTokenRequestProcess(isRefreshTokenForbidden())
  })
}

export function handleWorkerUserSessionLogout(callback: () => void) {
  const { emitWorkerSessionLogoutMessage } = useUserLogout()
  addAuthWorkerListener('userSessionLogout', () => {
    callback()
    emitWorkerSessionLogoutMessage()
  })
}
